import { PBTCrmCasesActionType } from './action-types';
import { PBTCrmCasesAction } from './actions';
import type { ICRMCasesState } from './types';

const initialState: ICRMCasesState = {
  cases: [],
  pageNumber: 1,
  pageSize: 15,
  totalPages: 0,
  totalCount: 0,
  gerWitCount: 0,
  loaCount: 0,
  duplicateCount: 0,
  isLoading: false,
  hasError: false,
  errorMessage: null,
  searchString: '',
};

export const pbtCrmCasesReducerName = 'pbtCrmCasesReducer';

export function pbtCrmCasesReducer(state: ICRMCasesState = initialState, action: PBTCrmCasesAction): ICRMCasesState {
  switch (action.type) {
    case PBTCrmCasesActionType.REQUEST_CRM_CASES:
      return {
        ...state,
        isLoading: true,
        hasError: false,
        errorMessage: null,
        searchString: action.payload.searchString,
      };

    case PBTCrmCasesActionType.RECEIVE_CRM_CASES: {
      const { response, searchString } = action.payload;
      return {
        ...state,
        isLoading: false,
        cases: response.cases,
        pageNumber: response.pageNumber,
        pageSize: response.pageSize,
        totalPages: response.totalPages,
        totalCount: response.totalCount,
        gerWitCount: response.gerWitCount,
        loaCount: response.loaCount,
        duplicateCount: response.duplicateCount,
        searchString,
      };
    }

    case PBTCrmCasesActionType.CRM_CASES_ERROR:
      return { ...state, isLoading: false, hasError: true, errorMessage: action.payload };

    default:
      return state;
  }
}
